export const BUTTON_LOCATION_BACKLOG = 'backlog';
export const BUTTON_LOCATION_KANBAN = 'kanban';
export const BUTTON_LOCATION_SCRUM = 'scrum';
